import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  _formatMore(content) {
    const dummyTextarea = document.createElement('textarea')
    dummyTextarea.innerHTML = content
    const htmlDecodedContent = dummyTextarea.value
    return htmlDecodedContent.replace(
      /`([^`]+)`+/g,
      '<span class="px-1 py-0.5 via-code-mono text-xs bg-neutral-700 dark:bg-neutral-800 rounded-md">$1</span>'
    )
  }

  async _runScripts() {
    const haml = 'https://unpkg.com/@highlightjs/cdn-assets@11.9.0/es/languages/haml.min.js'
    const ruby = 'https://unpkg.com/@highlightjs/cdn-assets@11.9.0/es/languages/ruby.min.js'
    const core = 'https://unpkg.com/@highlightjs/cdn-assets@11.9.0/es/core.min.js'

    const hamlLang = (await import(haml)).default
    const rubyLang = (await import(ruby)).default
    const hl = (await import(core)).default

    const [codeBoxRuby, codeBoxHaml] = this.element.querySelectorAll('pre code')

    hl.registerLanguage('haml', hamlLang)
    hl.registerLanguage('ruby', rubyLang)
    const rubyCodeHighlighted = hl.highlight(codeBoxRuby.innerHTML, { language: 'ruby' })
    const hamlCodeHighlighted = hl.highlight(codeBoxHaml.innerHTML, { language: 'haml' })

    codeBoxRuby.innerHTML = this._formatMore(rubyCodeHighlighted.value)
    codeBoxHaml.innerHTML = this._formatMore(hamlCodeHighlighted.value)
  }

  _buildStyles() {
    if (document.getElementById('via-code-sample') !== null) return
    const css = document.createElement('style')
    css.id = 'via-code-sample'
    css.innerHTML = `
      /* Based on https://github.com/primer/github-syntax-dark */
      pre.via-sample *:not(.hljs-comment) { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }
      pre code.hljs{display:block;overflow-x:auto;padding:1em}
      code.hljs{padding:3px 5px}
      .hljs{color:#c9d1d9;background:#0d1117}
      .hljs-doctag,.hljs-keyword,.hljs-meta .hljs-keyword,.hljs-template-tag,.hljs-template-variable,.hljs-type,.hljs-variable.language_{color:#ff7b72}
      .hljs-title,.hljs-title.class_,.hljs-title.class_.inherited__,.hljs-title.function_{color:#d2a8ff}
      .hljs-attr,.hljs-attribute,.hljs-literal,.hljs-meta,.hljs-number,.hljs-operator,.hljs-selector-attr,.hljs-selector-class,.hljs-selector-id,.hljs-variable{color:#79c0ff}
      .hljs-meta .hljs-string,.hljs-regexp,.hljs-string{color:#a5d6ff}
      .hljs-built_in,.hljs-symbol{color:#ffa657}
      .hljs-code,.hljs-comment,.hljs-formula{color:#8b949e; font-size: 0.9rem; }
      .hljs-name,.hljs-quote,.hljs-selector-pseudo,.hljs-selector-tag{color:#7ee787}
      .hljs-subst{color:#c9d1d9}
      .hljs-section{color:#1f6feb;font-weight:700}
      .hljs-bullet{color:#f2cc60}.hljs-emphasis{color:#c9d1d9;font-style:italic}
      .hljs-strong{color:#c9d1d9;font-weight:700}
    `
    document.body.appendChild(css)
  }

  async connect() {
    await this._runScripts()
    this._buildStyles()
  }
}
